export const EVENT = 'EVENT';
export const EMPTY_STATE = 'EMPTY_STATE';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const JITA_MESSAGE = 'JITA_MESSAGE';
export const MONTH_LABEL = 'MONTH_LABEL';
export const PINNED_ENGAGEMENT = 'PINNED_ENGAGEMENT';
export const SOURCE_EVENT = 'SOURCE_EVENT';